import { phoneRules } from '@/helpers/validation';
import { Form, Input } from 'antd';
import { FormInstance } from 'antd/lib';

interface Props {
  handleFinish: (values: unknown) => void;
  form: FormInstance<unknown>;
}

export default function FranchisorsForm({
  handleFinish,
  form,
}: Props): JSX.Element {
  return (
    <Form
      layout={'vertical'}
      name={'basic'}
      className={'admin-forgot-form'}
      onFinish={handleFinish}
      form={form}
      style={{ marginBlock: '24px' }}
    >
      <Form.Item
        name={'firstName'}
        label={<label style={{ color: '#9FA1AD' }}>First Name</label>}
        rules={[
          {
            required: true,
            message: "Please input user's first name!",
          },
        ]}
      >
        <Input size={'large'} />
      </Form.Item>

      <Form.Item
        name={'lastName'}
        label={<label style={{ color: '#9FA1AD' }}>Last Name</label>}
        rules={[
          {
            required: true,
            message: "Please input user's last name!",
          },
        ]}
      >
        <Input size={'large'} />
      </Form.Item>

      <Form.Item
        name={'email'}
        label={<label style={{ color: '#9FA1AD' }}>Email</label>}
        rules={[
          {
            required: true,
            message: "Please input user's email!",
          },
          {
            type: 'email',
            message: 'Please input a valid email!',
          },
        ]}
      >
        <Input size={'large'} />
      </Form.Item>

      <Form.Item
        name={'phone'}
        label={<label style={{ color: '#9FA1AD' }}>Phone</label>}
        rules={phoneRules}
      >
        <Input size={'large'} onWheel={(e) => e.currentTarget.blur()} />
      </Form.Item>
    </Form>
  );
}
